import type { SyncedAccountSalesArea } from '@/types/api';

interface AccountSalesAreaFormProps {
  formData: Partial<SyncedAccountSalesArea>;
  onChange: (data: Partial<SyncedAccountSalesArea>) => void;
}

export function AccountSalesAreaForm({ formData, onChange }: AccountSalesAreaFormProps) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
        <input type="text" value={formData.name || ''} onChange={(e) => onChange({ ...formData, name: e.target.value })} className="input w-full" required />
      </div>
      <div className="flex items-center">
        <input type="checkbox" id="asa-isEnabled" checked={formData.isEnabled ?? true} onChange={(e) => onChange({ ...formData, isEnabled: e.target.checked })} className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500" />
        <label htmlFor="asa-isEnabled" className="ml-2 text-sm text-gray-700">Enabled</label>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Sort Order</label>
        <input type="number" value={formData.sortOrder ?? ''} onChange={(e) => onChange({ ...formData, sortOrder: parseInt(e.target.value) || 0 })} className="input w-full" />
      </div>
    </div>
  );
}
